import { Common, color } from '@stockbit/ui';
import Link from 'next/link';

import AuthCardLayout from 'global/AuthCardLayout';
import Image from 'global/Image';

import { successRegisterIcon } from '../../../assets/base64icon';

const { Button, Flex, Text, Iconmoon, IconWrapper } = Common;

function SuccessfulRegistration() {
  return (
    <AuthCardLayout withLogo={false} wrapperClassName="register">
      <Flex justify="center" align="center" mt="20px">
        <Image style={{ width: 80 }} src={successRegisterIcon} />
      </Flex>

      <Flex justify="center" align="center">
        <Text size="20px" family="bold" pr="5px">
          Registration Successful
        </Text>
        <IconWrapper>
          <Iconmoon
            className="icon-toolbar_valid"
            size="24px"
            color={color.primary}
          />
        </IconWrapper>
      </Flex>

      <Text color={color.highgray} style={{ lineHeight: 1.5 }} align="center">
        We have sent you an email to create your password should you wish to
        login using your username/email
      </Text>

      <Link href="/stream">
        <Button
          type="primary"
          mx="auto"
          mb="20px"
          height="44px"
          block
          as="a"
          style={{ width: 'fit-content', paddingLeft: 30, paddingRight: 30 }}
          className="btn-successful-register"
        >
          <Text family="bold" color={color.light}>
            Ok
          </Text>
        </Button>
      </Link>
    </AuthCardLayout>
  );
}

export default SuccessfulRegistration;
